import { render, staticRenderFns } from "./TransactionSplit.vue?vue&type=template&id=3d0f0ad6&scoped=true"
import script from "./TransactionSplit.vue?vue&type=script&lang=js"
export * from "./TransactionSplit.vue?vue&type=script&lang=js"
import style0 from "./TransactionSplit.vue?vue&type=style&index=0&id=3d0f0ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f0ad6",
  null
  
)

export default component.exports